import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { map, Observable } from "rxjs";

import { isUserOwner } from "../store/authentication";
import { AppState } from "../store/store";

@Injectable({
  providedIn: "root",
})
export class OwnerGuard {
  private router = inject(Router);
  private store = inject<Store<AppState>>(Store);

  canActivate(): Observable<boolean> {
    return this.store.select(isUserOwner).pipe(
      map(isOwner => {
        if (isOwner) {
          return true;
        }
        void this.router.navigate(["/doc-upload"]);
        return false;
      })
    );
  }
}
